import HttpUtil from "ips/ac/util/HttpUtil";
import Util from "ips/ac/util/Util";

export default {
  get(sOrderGuid: string): Promise<any> {
    const sUrl = this._getServiceUrl() + "/mapping/order/" + sOrderGuid;
    return HttpUtil.get(sUrl);
  },

  createOrUpdate(sOrderGuid: string, sStatusGuid: string): Promise<any> {
    const sUrl = `${this._getServiceUrl()}/${sStatusGuid}/mapping/order/${sOrderGuid}`;
    return HttpUtil.post(sUrl, null, null);
  },

  update(sGuid: string, sDescription: string): Promise<any> {
    const sUrl = `${this._getServiceUrl()}/mapping/${sGuid}`;
    const oBody = { description: sDescription };
    return HttpUtil.patch(sUrl, oBody);
  },

  _getServiceUrl(): string {
    const sBaseUrl = Util.getIpsConfig().getProperty("/RestApi");
    return sBaseUrl + "/order/internalstatus";
  },
};